import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DragLayer } from 'react-dnd';

@DragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getSourceClientOffset(),
    clientOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging(),
}))
class DragPreview extends Component {
    constructor(props) {
        super(props);
        this.state = { layerStyle: { display: 'none' } };
    }

	getItemStyles = () => {
	    const { clientOffset } = this.props;
	    if (!clientOffset) {
	        return { display: 'none' };
	    }
	    let { x, y } = clientOffset;
	    const transform = `translate(${x}px, ${y}px)`;
	    return {
	        transform,
	        WebkitTransform: transform,
	    };
	};

	countSelectedNumber = () => {
	    let { item } = this.props;
	    let selectedNodes = item.selectedNodes;

	    let include = selectedNodes.find(node => node.props.dataRef.proid === item.dataRef.proid);

	    if (selectedNodes.length === 1 && include) {
	        return item.dataRef.title;
	    } else {
	        return include ? '+' + selectedNodes.length : '+' + (selectedNodes.length + 1);
	    }

	};

	render() {
	    if (navigator.userAgent.indexOf('MSIE') > -1 ||
			navigator.userAgent.indexOf('Trident') > -1 ||
			navigator.userAgent.indexOf('Edge') > -1) {
	        return null;
	    }
	    let { item } = this.props;

	    if (item === null || item && !item.metaTree) {
	        return null;
	    }

	    return (
	        <div>
	            <div style={this.getItemStyles()} className='tree-node-layer'>
	                <span>
	                    {
	                        item.selectedNodes.length === 0
	                            ? item.dataRef.title
	                            : this.countSelectedNumber()
	                    }
	                </span>

	            </div>
	        </div>
	    );
	}
}

function mapStateToProps(state) {
    return {};
}

export default connect(
    mapStateToProps,
)(DragPreview);
